module.exports = __webpack_public_path__ + "img/nullBox.0f97b998.png";